import { render, staticRenderFns } from "./MitHRManagePeoplePage2.vue?vue&type=template&id=79f22a9c&scoped=true"
import script from "./MitHRManagePeoplePage2.vue?vue&type=script&lang=js"
export * from "./MitHRManagePeoplePage2.vue?vue&type=script&lang=js"
import style0 from "./MitHRManagePeoplePage2.vue?vue&type=style&index=0&id=79f22a9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f22a9c",
  null
  
)

export default component.exports